import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatePickerControl } from '../../../controls/setup-wizard/date-picker-control/date-picker-control';

@Component({
	selector: 'app-date-picker-field',
	standalone: true,
	imports: [DatePickerControl],
	templateUrl: './date-picker-field.html',
})
export class DatePickerField {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	formGroup = input.required<FormGroup>();
}
